import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './styles.module.scss';

export class FaqContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: null
    };

    this.openItem = this.openItem.bind(this);
  }

  openItem(id) {
    return () => {
      if (this.state.open === id) {
        return this.setState({ open: null });
      }
      this.setState({ open: id });
    };
  }

  render() {
    const { children } = this.props;
    const { open } = this.state;
    const childrenWithProps = React.Children.map(children, (child, index) =>
      React.cloneElement(child, {
        onClick: this.openItem(index),
        open: open === index
      })
    );

    return (
      <div className="d-flex flex-column">
        {childrenWithProps}
      </div>
    );
  }
}

export const FaqItem = ({ open, question, children, onClick }) => (
  <div className={`card ${styles.faqItem}`}>
    <div className={`card-header ${styles.question} ${open ? styles.open : styles.closed}`} onClick={onClick}>
      <h5>{question}</h5>
      {open ? (
        <FontAwesomeIcon icon="chevron-up" />
      ) : (
        <FontAwesomeIcon icon="chevron-down" />
      )}
    </div>
    <Collapse isOpen={open}>
      <div className={styles.answer}>
        {children}
      </div>
    </Collapse>
  </div>
);

FaqItem.propTypes = {
  open: PropTypes.bool,
  question: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func
};
